<template>
  <div :class="{'district': districtIsSelected}">
    <transition name="fade">
      <div v-if="loading.district" class="statistics__loader-wrapper">
        <Spinner />
      </div>
    </transition>
    <h2 v-if="districtIsSelected">Opkomst {{ selectedDistrict.Title.Naam._text }}</h2>
    <h2 v-else>Live statistieken</h2>
    <div :class="['statistics__graph-pie-container']">
      <div v-if="!districtIsSelected" class="statistics__graph-pie statistics__graph-pie--one">
        <PieChart :data="{
          datasets: [
            {
              values: [liveStatistics.completed, liveStatistics.total - liveStatistics.completed],
              color: [getProvinceSetting.color, 'grey']
            }
          ],
          title: 'Gemeentes binnen',
          labels: ['Binnen', 'Niet binnen'],
        }" class="chart"
        />
      </div>
      <div :class="['statistics__graph-pie statistics__graph-pie--two']">
        <PieChart :data="{
          datasets: [
            {
              values: [getTurnupPercentage, Math.round((100 - getTurnupPercentage) * 10) / 10],
              color: [getProvinceSetting.color, 'grey']

          }],
          legendPosition: districtIsSelected ? 'left' : 'top',
          title: !districtIsSelected ? 'Opkomst' : '',
          labels: ['Gestemd', 'Niet gestemd'],
          unit: '%'
        }" class="chart"
        />
      </div>
    </div>
    
  </div> 
</template>

<script>
import { mapState, mapGetters } from "vuex";
import PieChart from "../charts/PieChart.vue";
import Spinner from "../Spinner.vue";

export default {
  components: { PieChart, Spinner },
  data() {
    return {
      provincialVoteView: false,
      sortOnValues: false
    };
  },
  computed: {
    ...mapState({
      demographic: state => state.feed.provincialData.demographic,
      selectedDistrict: state => state.feed.selectedDistrict,
      seats: state => state.feed.provincialData.seats,
      loading: state => state.feed.loading,
      lastUpdated: state => state.feed.lastUpdated
    }),
    ...mapGetters("feed", [
      "provincialPartySeats",
      "votingBehavior",
      "districtPartyResults",
      "getCompletedDistricts",
      "getProvincialTotals",
      "getProvinceSetting",
      "provincialPartyVotes"
    ]),
    liveStatistics() {
      return this.getCompletedDistricts(this.getProvinceSetting.key);
    },

    districtIsSelected() {
      return Object.keys(this.selectedDistrict).length;
    },
    getTurnupPercentage() {
      return Number(
        this[
          this.districtIsSelected ? "selectedDistrict" : "demographic"
        ].Groep.find(
          g => g.Naam._text === "Opkomst"
        ).Verkiezing[0].Perc._text.replace(",", ".")
      );
    }
  },
  methods: {}
};
</script>

<style>
/* styling is inherited from parent */
</style>
